module.exports = __webpack_public_path__ + "static/img/introduce_3.cc18d12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/popup/introduce_3.png
// module id = vDPF
// module chunks = 1